import { getFetchWrapper } from "@syf-api-library/core";
import { creditHealthUrl } from "../endpoints.js";
const mutationFnFactory = (config, headers = {}) => {
  const fetchWrapper = getFetchWrapper(config);
  return (payload) => {
    return fetchWrapper(creditHealthUrl, {
      method: "PUT",
      body: JSON.stringify({
        "cipher.accountId": payload["cipher.accountId"],
        accountIdType: payload.accountIdType,
        enrolled: payload.enrolled
      }),
      headers
    });
  };
};
export {
  mutationFnFactory as default
};
//# sourceMappingURL=mutation.js.map
